import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsDataClassificationsRoute: InvariantJiraRoute = {
	name: 'project-settings-classic-data-classifications',
	path: '/plugins/servlet/project-config/:projectKey/data-classifications',
	exact: true,
};
